import routes from '../routes';
import CaseComponent from '../../Case/Add/Case';
import CasesView from '../../Case/View/CasesView';
import CloseCaseForm from '../../Case/Close/CloseCaseForm';
import InformationView from '../../Case/InformationView/InformationView';
import ClosedCasesBulk from '../../ClosedCasesBulk/ClosedCasesBulk';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';

const moduleRoutes: RoutePathsFn = () => ([
  {
    paths: [routes.ADD],
    component: CaseComponent,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.CASEVIEW, routes.CASEDEFAULT],
    component: CasesView,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [
      routes.EDIT,
      routes.CASECHILDREN,
      routes.CASEINFO,
      routes.CASECOMPANIONS,
      routes.CASEMATCHES,
      routes.CASEPOSTER,
      routes.ALERTSBYCASE,
      routes.TRANSFERCASE,
      routes.TRANSFERCASEADD
    ],
    component: InformationView,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.CLOSE],
    component: CloseCaseForm,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  },
  {
    paths: [routes.CLOSED_CASES_BULK],
    component: ClosedCasesBulk,
    policies: [UserTypes.CASEMANAGER, UserTypes.ADMIN]
  }
]);

export const casesModule = (): IRouteModule => ({
  name: RoutesModules.CASES,
  routes: moduleRoutes(),
  navbar: routes.CASEDEFAULT,
  sidebar: [
    {
      navTitle: 'Open cases',
      route: routes.CASEDEFAULT,
      path: '/view/open',
      isMainPath: true
    },
    {
      navTitle: 'Closed cases',
      route: routes.CASEDEFAULT,
      path: '/view/closed'
    },
    {
      navTitle: 'All cases',
      route: routes.CASEDEFAULT,
      path: '/view/all'
    },
    {
      navTitle: 'Restricted cases',
      route: routes.CASEDEFAULT,
      path: '/view/restricted'
    },
    {
      isFormLink: true,
      navTitle: 'Add new case',
      route: routes.ADD
    }
  ]
});